import type { PillarId, PillarResult } from "@moneymap/domain";

const icons: Record<PillarId, string> = {
  "cash-flow": "⇄",
  "safety-buffer": "◒",
  "health-protection": "+",
  "life-protection": "◇",
  "debt": "↘",
  "goals": "⚑",
  "future": "✦"
};

const statusLabel: Record<PillarResult["status"], string> = {
  urgent: "Mission now",
  attention: "Build next",
  steady: "Shield active",
  unknown: "Needs intel"
};

export function ProgressJourney({ pillars, compact = false }: { pillars: PillarResult[]; compact?: boolean }) {
  return (
    <div className={`progress-journey ${compact ? "compact" : ""}`} aria-label="Your seven-stage financial journey">
      {pillars.map((pillar, index) => (
        <article className={`journey-stop status-card-${pillar.status}`} key={pillar.id}>
          <div className="journey-node" aria-hidden="true"><span>{icons[pillar.id]}</span></div>
          <div className="journey-copy">
            <small>Stage {index + 1}</small>
            <strong>{pillar.label}</strong>
            <span>{statusLabel[pillar.status]}</span>
          </div>
        </article>
      ))}
    </div>
  );
}

export function ProtectionVault({ pillars }: { pillars: PillarResult[] }) {
  const shields = pillars.filter((pillar) => ["safety-buffer", "health-protection", "life-protection"].includes(pillar.id));
  return (
    <div className="protection-vault">
      {shields.map((shield) => (
        <article className={`shield-card status-card-${shield.status}`} key={shield.id}>
          <div className="shield-icon" aria-hidden="true"><span>{icons[shield.id]}</span></div>
          <div><p>{statusLabel[shield.status]}</p><h3>{shield.label}</h3><span>{shield.summary}</span></div>
        </article>
      ))}
    </div>
  );
}
